import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import ActivityMapping from "./activity-mapping/activity-mapping";
import CategoryMapping from "./category-mapping/category-mapping";
import UsersCategoryMapping from "./users-category-mapping/users-category-mapping";
import UsersActivityMapping from "./users-activity-mapping/users-activity-mapping";
import ProjectMapping from "./project-mapping/project-mapping";
import ConfigDataMapping from "./config-mapping/config-mapping";
import { SETTING_PROJECT_VIEW, SETTING_CATEGORY_VIEW, SETTING_ACTIVITY_VIEW, SETTING_CATEGORY_MAP_MAP, SETTING_ACTIVITY_MAP_MAP, CONFIG_SETTING_DATA } from "../../config/permissions";
import ProtectedSection from "../../components/protected/ProtectedSection";
import { getFilteredOptions } from "../../common/helpers/permissions";
import { hasPermission } from "../../components/protected/ProtectedSection";
export const SettingCard = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const [items, setItems] = useState([])

  useEffect(() => {
    const fItems = ([
      { label: "Project Mapping", icon: "pi pi-book", permission: SETTING_PROJECT_VIEW },
      { label: "Category Mapping", icon: "pi pi-inbox", permission: SETTING_CATEGORY_VIEW },
      { label: "Activity Mapping", icon: "pi pi-folder", permission: SETTING_ACTIVITY_VIEW },
      { label: "Users Category Mapping", icon: "pi pi-users", permission: SETTING_CATEGORY_MAP_MAP },
      { label: "Users Activity Mapping", icon: "pi pi-users", permission: SETTING_ACTIVITY_MAP_MAP },
      { label: "Config Mapping", icon: "pi pi-cog", permission: CONFIG_SETTING_DATA },
    ]);
    setItems(fItems);
  }, [])

  const ActiveTab = () => {
    switch (activeIndex) {
      case 0:
        return <ProtectedSection permissions={[SETTING_PROJECT_VIEW]}><ProjectMapping /></ProtectedSection>;
      case 1:
        return <ProtectedSection permissions={[SETTING_CATEGORY_VIEW]}><CategoryMapping /></ProtectedSection>;
      case 2:
        return <ProtectedSection permissions={[SETTING_ACTIVITY_VIEW]}><ActivityMapping /></ProtectedSection>;
      case 3:
        return <ProtectedSection permissions={[SETTING_CATEGORY_MAP_MAP]}><UsersCategoryMapping /></ProtectedSection>;
      case 4:
        return <ProtectedSection permissions={[SETTING_ACTIVITY_MAP_MAP]}><UsersActivityMapping /></ProtectedSection>;
      case 5:
        return <ProtectedSection permissions={[CONFIG_SETTING_DATA]}><ConfigDataMapping /></ProtectedSection>;
      default:
        return <ProtectedSection permissions={[SETTING_CATEGORY_VIEW]}><CategoryMapping /></ProtectedSection>;
    }
  };

  const getTabBody = (tab) => {
    return (
      <div>
        <span className={tab.icon} style={{ marginRight: "3%" }}></span>
        {tab.label}
      </div>
    );
  };

  return (
    <Fragment>
      <div className="card">
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >
          {items.map((tab) => {
            return (
              <TabPanel key={tab.label} header={getTabBody(tab)} disabled={!hasPermission(tab.permission)}>
                <p className="m-0">
                  <ActiveTab />
                </p>
              </TabPanel>
            );
          })}
        </TabView>
      </div>
    </Fragment>
  );
};
